import React from "react";
import { Box, BoxProps } from "@mui/material";

const TopCornerBorderQRCode: React.FC<BoxProps> = (props) => {
  return (
    <Box {...props}>
        <Box component="img" src="/images/LeftUpperCorner.svg" alt="Wallenstam logo"/>
        <Box component="img" src="/images/RightUpperCorner.svg" alt="Wallenstam logo"/>
    </Box>
  )
};

export default TopCornerBorderQRCode;
